import { render, staticRenderFns } from "./PostConfirm.vue?vue&type=template&id=fb02318a&scoped=true&"
import script from "./PostConfirm.vue?vue&type=script&lang=js&"
export * from "./PostConfirm.vue?vue&type=script&lang=js&"
import style0 from "./PostConfirm.vue?vue&type=style&index=0&id=fb02318a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb02318a",
  null
  
)

export default component.exports